module.exports = require('./helpers/bundle-url').getBundleURL('hzsxP') + "logo-dark.eefe0b7f.svg";